import { get } from "lodash"
import createModule from "../createModule"
import { getRole } from "helpers/permissions/roles"
import view from "./view"
import { getAvailableCurrencyOptions } from "selectors/currency"
import { getResources, getModel, getFavoritesScreen, getRecentResources } from "./selectors"
import { getModels } from "./selectors/portfolios"
import { Creators } from "modules/resources/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators as NotificationsCreators } from "modules/notifications/model"
import { getIsOpPro, getIsIntradayAccountEnabled, getDefaultCurrencyId } from "modules/account-root/selectors"
import withOutletContext from "hocs/withOutletContext"
import { MODELS_QUERY } from "resources/models"
import { BASKETS_QUERY } from "resources/baskets"
import { SUPPORTED_CURRENCIES_QUERY } from "resources/currencies"
import { FORECAST_LIST_QUERY } from "resources/forecasts"

export default withOutletContext(createModule({
  view,
  externalProps: (state, props) => ({
    account: get(state, "global.selected.account"),
    accountId: get(state, "global.selected.accountId"),
    memberId: get(state, "user.id"),
    isOpPro: getIsOpPro(state),
    role: getRole(state, props),
  }),
  required: ["account", "accountId", "isOpPro"],
  data: [BASKETS_QUERY, MODELS_QUERY, SUPPORTED_CURRENCIES_QUERY, {
    resource: "accountWatchlists",
    url: () => ({
      id: "account-watchlists",
      query: "query { watchlists { id, name, description, alias, count, lastUpdated } }",
    }),
  }, {
    resource: "accountResearchTopics",
    url: ({ isOpPro }) => {
      if (isOpPro) {
        return null
      }

      return {
        id: "account-research-topics",
        query: "query { researchTopics { id, name, description, alias, lastUpdated, referenceInstrument { type, securityId { ticker, mic, country }, portfolioId } } }",
      }
    },
  }, {
    resource: "accountPortfolios",
    url: ({ isOpPro }) => ({
      id: "account-portfolios",
      query: `query {
        portfolios {
          id
          description
          name
          alias
          defaultModelId
          availableFrom
          lastUpdated
          rolloverPositionSetToCurrentDate
          ${isOpPro ? "" : "intradayEnabled"}
        }
      }`,
    }),
  }, {
    resource: "userFavoriteResources",
    url: ({ accountId }) => ({
      id: `userFavoriteResources-${accountId}`,
      url: "/api/users/me/preferences",
      payload: {
        items: [{ type: "favoriteResources", accountId }],
      },
    }),
  }, {
    ...FORECAST_LIST_QUERY,
    as: null,
  }, {
    resource: "resourcesPermissions",
    url: () => ({
      id: "resource-permissions",
      query: `query {
          resources {
            id
            alias
            type
            permissionLevel
          }
        }`,
    }),
  }, {
    resource: "recentResources",
    url: ({ account }) => `/api/${account}/recent-resources`,
  }],
  mapStateToProps: (state, props) => ({
    resources: getResources(state, props),
    model: getModel(state, props),
    models: getModels(state, props),
    security: state.modules.portfolioRoot.security,
    recentResources: getRecentResources(state, props),
    favoritesScreen: getFavoritesScreen(state, props),
    intradayAccountEnabled: getIsIntradayAccountEnabled(state, props),
    accountDefaultCurrencyId: getDefaultCurrencyId(state),
    supportedCurrencies: getAvailableCurrencyOptions(state),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile2,
    closeSecurityProfile: ProfileCreators.closeSecurityProfile,
    openDialog: DialogCreators.open,
    closeDialog: DialogCreators.close,
    addNotification: NotificationsCreators.add,
  },
}))
